<template>
  <div id="login">
    <div class="basic-box">
      <div class="row">
        <div class="title col-12">{{ $t('authenticate.login.tile') }}</div>
      </div>
      <div class="row">
        <base-input
          :placeHolder="$t('authenticate.login.email')"
          @baseInputValue="emailChanged"
          @enter="login"
          class="col-12"
        />
      </div>
      <div class="row">
        <base-input
          :placeHolder="$t('authenticate.login.password')"
          :type="'password'"
          @baseInputValue="passwordChanged"
          @enter="login"
          class="col-12"
        />
      </div>
      <div class="row">
        <base-button
          @click="login"
          :text="$t('authenticate.login.buttonText')"
          class="col-12"
        />
        <a @click="showResetPasswordModal" class="reset-password-link">{{
          $t('authenticate.login.resetPassword')
        }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

import BaseInput from '@/components/shared/elements/BaseInput';
import BaseButton from '@/components/shared/elements/BaseButton';
import ResetPasswordModal from '@/components/shared/modals/ResetPasswordModal';

export default {
  name: 'Login',
  components: {
    BaseInput,
    BaseButton,
  },
  data() {
    return {
      user: {
        email: undefined,
        password: undefined,
      },
    };
  },
  methods: {
    ...mapActions({
      loginUser: 'users/loginUser',
    }),
    login() {
      this.loginUser({ user: this.user })
        .then((result) => {
          if (result.user.status === 0) {
            this.$swal(
              this.$t('login.error.banned.title'),
              this.$t('login.error.banned.message'),
              'error'
            );
          } else {
            this.$gtag.event('login', { method: 'Email' });
            window.location.href = '/';
          }
        })
        .catch((err) => {
          if (err.code == 402) {
            this.$swal(
            this.$t('login.paymentError.title'),
            this.$t('login.paymentError.message'),
            'error',
          );
          } else {
            this.$swal(
              this.$t('login.error.title'),
              this.$t('login.error.message'),
              'error'
            );
          }
        });
    },
    emailChanged(email) {
      this.user.email = email;
    },
    passwordChanged(password) {
      this.user.password = password;
    },
    showResetPasswordModal() {
      this.$eventBus.showModal({
        bind: {
          is: ResetPasswordModal,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#login {
  //background-color: $light-background-color;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  .basic-box {
    width: 70%;
  }
  .row {
    min-height: 60px;
    display: flex;
    align-items: center;
  }
  .reset-password-link {
    text-align: center;
    margin: 10px auto auto auto;
    cursor: pointer;
    color: $primary-color;
    &:hover {
      color: $primary-hover-color;
      text-decoration: none;
    }
  }
}
</style>

